import { Injectable } from '@angular/core';
import { CommonFormService } from '../../../../services/common-form.service';
import { HeatGeneratorDetailsOptions, RadioQuestionOverride } from '@nx-customer-apps/shared/interfaces';
import { Question } from '@nx-customer-apps/shared/utils';
import { FormKeys } from '@nx-customer-apps/shared/enums';
import { FormToolsService } from '../../../../services/form-tools.service';

@Injectable({
    providedIn: 'root'
})
export class HeatGeneratorDetailsFormService {
    constructor(
        private commonFormService: CommonFormService,
        private formToolsService: FormToolsService
    ) {}

    public getHeatGeneratorDetailsQuestions(options?: HeatGeneratorDetailsOptions): Question[] {
        const installationYear = this.commonFormService.getInstallationYear(options);

        if (!options) {
            return [installationYear];
        }
        const questions: Question[] = [];

        const installationYearOverride = options.questions?.[FormKeys.InstallationYear];
        if (installationYearOverride) {
            installationYear.value = installationYearOverride.value || options.buildingConstructionYear;
        }
        questions.push(installationYear);

        const boilerTypeOverride = options.questions?.[FormKeys.BoilerType] as RadioQuestionOverride;

        if (boilerTypeOverride && !boilerTypeOverride.options) {
            throw Error('Boiler type question must have specified options property');
        }

        if (boilerTypeOverride) {
            const boilerType = this.commonFormService.getBoilerType(boilerTypeOverride);
            questions.push(boilerType);
        }
        const hasBoilerTypeSubquestionOverrides =
            options.questions?.[FormKeys.BoilerTypeSubquestion] ||
            options.questions?.[FormKeys.LowTemperature] ||
            options.questions?.[FormKeys.WarmWaterByHeatGenerator];
        const isBoilerTypeSubquestion =
            hasBoilerTypeSubquestionOverrides || this.formToolsService.hasBoilerOptionsToAsk(options.selectedInstallationType);

        if (isBoilerTypeSubquestion) {
            const boilerTypeSubquestion = this.commonFormService.getBoilerTypeSubquestion(options);
            questions.push(boilerTypeSubquestion);
        }

        const operatingModeOverride = options.questions?.[FormKeys.HeatPumpOperatingMode] as RadioQuestionOverride;

        if (operatingModeOverride?.options) {
            const operatingMode = this.commonFormService.getHeatPumpOperatingMode(operatingModeOverride);
            questions.push(operatingMode);
        }

        const nominalPowerOverride = options.questions?.[FormKeys.NominalPower];
        if (nominalPowerOverride) {
            const nominalPower = this.commonFormService.getNominalPower(options);
            questions.push(nominalPower);
        }

        const hasGasLossExhaustKnownOverrides = options.questions?.[FormKeys.GasLossExhaustKnown] || options.questions?.[FormKeys.IsKnown];
        if (hasGasLossExhaustKnownOverrides) {
            const gasLossExhaustKnown = this.commonFormService.gasLossExhaustKnown(options);
            questions.push(gasLossExhaustKnown);
        }

        const gasLossExhaustOverride = options.questions?.[FormKeys.GasLossExhaust];
        if (gasLossExhaustOverride) {
            const gasLossExhaust = this.commonFormService.getGasLossExhaust(options);
            questions.push(gasLossExhaust);
        }

        return questions;
    }
}
